import {Logger} from '../../utils/Logger';
import {Injectable} from '@angular/core';
import {PortfolioService} from '../../service/portfolio.service';
import {ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot} from '@angular/router';

@Injectable()
export class PortfolioCreationGuard implements CanActivate {
    private readonly router: Router;
    private readonly portfolioService: PortfolioService;

    constructor(portfolioService: PortfolioService, router: Router) {
        this.portfolioService = portfolioService;
        this.router = router;
    }

    async canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Promise<boolean> {
        const tempPortfolioId = route.params.tempPortfolioId;
        const portfolioCreationData = await this.portfolioService.getLocalPortfolioCreationData(tempPortfolioId);
        if (portfolioCreationData) {
            return true;
        } else {
            Logger.log(`Portfolio creation data was not found for temp-portfolio-id: [${tempPortfolioId}].`);
            this.router.navigate(['/investordashboard']);
            return false;
        }
    }
}